// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo--logo--3ZywIgz"};